import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { OtaOverviewState } from './useOtaOverview';

/** One row per gateway that reported its versions, against the latest firmware for its model. */
export const DeviceStatusTab: React.FC<{ ota: OtaOverviewState }> = ({ ota }) => {
  const { t } = useI18n();
  const { deviceStatus, figures } = ota;

  if (deviceStatus.length === 0) {
    return (
      <div className="devices-status-list">
        <div className="empty-state">
          <div className="empty-icon">📱</div>
          <h3>{t('otaUpdates.noDeviceVersionsTracked')}</h3>
          <p>{t('otaUpdates.noDeviceVersionsHint')}</p>
          {figures.models.length > 0 && <p className="empty-meta">{t('otaUpdates.availableModels', { models: figures.models.join(', ') })}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="devices-status-list">
      <table className="ota-table">
        <thead>
          <tr>
            <th>{t('otaUpdates.device')}</th>
            <th>{t('otaUpdates.type')}</th>
            <th>{t('otaUpdates.currentVersion')}</th>
            <th>{t('otaUpdates.latestVersion')}</th>
            <th>{t('otaUpdates.status')}</th>
            <th>{t('otaUpdates.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {deviceStatus.map((device) => (
            <tr key={device.device_id}>
              <td>
                <div className="device-info">
                  <strong>{device.device_name}</strong>
                  <span className="device-id">{device.device_id}</span>
                </div>
              </td>
              <td><span className={`type-badge ${device.device_type}`}>{device.device_type.replace('_', ' ')}</span></td>
              <td className="version">{device.current_version}</td>
              <td className="version">{device.latest_version}</td>
              <td>
                {device.needs_update
                  ? <span className="status-badge needs-update">{t('otaUpdates.updateAvailable')}</span>
                  : <span className="status-badge up-to-date">{t('otaUpdates.upToDate')}</span>}
              </td>
              <td>{device.needs_update && <button type="button" className="btn btn-sm btn-primary">{t('otaUpdates.update')}</button>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
